import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface MonthPickerProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function MonthPicker({ value, onChange, placeholder = 'Alle Monate' }: MonthPickerProps) {
  const [show, setShow] = useState(false);
  const [currentYear, setCurrentYear] = useState(
    value ? Number(value.split('-')[0]) : new Date().getFullYear()
  );

  const months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  const formatLabel = (val: string) => {
    if (!val) return placeholder;
    const [y, m] = val.split('-');
    return `${monthNames[Number(m) - 1]} ${y}`;
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShow(prev => !prev)}
        className="px-4 py-2 border border-[#e9e9e9] rounded-lg text-[14px] text-[#1c1c1c] bg-white hover:border-[#0084c7] min-w-[160px] text-left"
      >
        {formatLabel(value)}
      </button>

      {show && (
        <div className="absolute mt-2 w-[260px] bg-white border border-[#e9e9e9] rounded-[12px] shadow-lg p-4 z-30">
          <div className="flex items-center justify-between mb-4">
            <button onClick={() => setCurrentYear(y => y - 1)}>
              <ChevronLeft className="size-5 text-[#6b6b6b]" />
            </button>
            <div className="text-sm font-medium">{currentYear}</div>
            <button onClick={() => setCurrentYear(y => y + 1)}>
              <ChevronRight className="size-5 text-[#6b6b6b]" />
            </button>
          </div>

          <div className="grid grid-cols-3 gap-2">
            {months.map((month, index) => {
              const monthStr = `${currentYear}-${String(index + 1).padStart(2, '0')}`;
              const isSelected = value === monthStr;
              return (
                <button
                  key={month}
                  onClick={() => { onChange(monthStr); setShow(false); }}
                  className={`h-10 rounded-md text-sm transition-colors ${
                    isSelected ? 'bg-[#0084c7] text-white' : 'hover:bg-[#f5f5f5]'
                  }`}
                >
                  {month}
                </button>
              );
            })}
          </div>

          {value && (
            <button
              onClick={() => { onChange(''); setShow(false); }}
              className="mt-3 w-full text-center text-[13px] text-[#6b6b6b] hover:text-[#1c1c1c] transition-colors"
            >
              Zurücksetzen
            </button>
          )}
        </div>
      )}
    </div>
  );
}